import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import useStockStore from '../../store'
import { defer } from 'react-router-dom'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Stock On Hand loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Stock On Hand loader')

  // Populating the stock take templates dropdown before the page loads
  const stocktakeTemplates = useStockStore
    .getState()
    .getStocktakeTemplates(false)

  // Return a deferred promise to enable React Router's built-in loading state
  // This approach is currently required for compatibility with our PageLoadingSupport.tsx logic,
  // even though defer() is considered legacy in newer React Router versions.
  return defer({ data: stocktakeTemplates })
}
